// Source
import * as Instance from "./Instance";
import * as ModelHelperSrc from "../model/HelperSrc";

export const dataList = (callback: ModelHelperSrc.IapiCallback): void => {
    Instance.api
        .get<ModelHelperSrc.Iresponse>(`/localization/data_list`, {
            headers: {
                "Content-Type": "application/json"
            }
        })
        .then((response) => {
            return callback(response.data);
        })
        .catch((error: Error) => {
            return callback(error);
        });
};
